module.exports = __webpack_public_path__ + "static/RetailDevice-8c0e186ebc432d9887bd70dcb5c49cfe.png";